import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IProfile, IResponse, IUser } from '@interfaces/index';
import { debounceTime, switchMap } from 'rxjs';
import { AppService } from '@ui-components/services';
import { UserService } from '../../services/user.service';
import { UserModalComponent } from '../user-modal/user-modal.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent {

  columns = ['org', 'name', 'email', 'workplace', 'role', 'status', 'actions'];
  form: FormGroup;
  loading = false;
  profile: IProfile | null = null;
  users: IUser[] = [];
  private destroyRef: DestroyRef;

  constructor(
    protected _app_service: AppService,
    protected _user_service: UserService,
    protected _fb: FormBuilder,
    public dialog: MatDialog,
    destroyRef: DestroyRef
  ) {
    this.form = this._fb.group({
      search: [null]
    });
    this.destroyRef = destroyRef;
  }

  ngOnInit(): void {
    this._app_service.selectedManagementGroup$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.loadUsers();
    });

    this._app_service.getProfile().pipe(
      switchMap((response: IResponse<IProfile>) => {
        this.profile = response.data;
        return this._user_service.getUsers(this.profile.org_id);
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: IResponse<IUser[]>) => {
      this.users = response.data;
    });

    this.form.valueChanges.pipe(
      debounceTime(800),
      switchMap(() => {
        const search = this.form.get('search')?.value === '' ? null : this.form.get('search')?.value;
        return this._user_service.getUsers((this.profile as IProfile).org_id, search);
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: IResponse<IUser[]>) => {
      this.users = response.data;
      this.loading = false;
    });
  }

  loadUsers(): void {
    if (this.profile) {
      this.loading = true;
      this._user_service.getUsers(this.profile.org_id).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: IResponse<IUser[]>) => {
        this.users = response.data;
        this.loading = false;
      });
    }
  }

  clearSearch(): void {
    this.form.reset();
    this.loadUsers();
  }

  showUsersModal(user: IUser | null = null): void {
    const dialog_ref = this.dialog.open(UserModalComponent, {
      width: '600px',
      data: user
    });

    dialog_ref.afterClosed().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((saved: boolean) => {
      if (saved) {
        this.loadUsers();
      }
    });
  }
}
